import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectPage = (store: StoreSchema) =>
	store.instanceEvents.paginatedInstanceEvents.currentPage